import "./index.css";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports, module) {
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      function classNames() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames;
        });
      } else {
        window.classNames = classNames;
      }
    })();
  }
});

// src/ProductCard/ProductCard.tsx
var import_classnames2 = __toESM(require_classnames(), 1);
import Box7 from "@cloudscape-design/components/box";
import Button3 from "@cloudscape-design/components/button";
import Container2 from "@cloudscape-design/components/container";
import Link5 from "@cloudscape-design/components/link";
import Icon5 from "@cloudscape-design/components/icon";
import SpaceBetween5 from "@cloudscape-design/components/space-between";
import { useAppTranslation as useAppTranslation5 } from "@amzn/awsmp-max-translations";

// src/Citations/CitationBadge.tsx
import * as React from "react";
import Link from "@cloudscape-design/components/link";
import Popover from "@cloudscape-design/components/popover";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Icon from "@cloudscape-design/components/icon";

// src/Citations/citation-utils.ts
function getCitationDomainLabel(url) {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.includes("amazon.com") ? "AWS" : "External";
  } catch {
    return "External";
  }
}
function getCitationIdLabel(id) {
  return `[${id}]`;
}

// src/Citations/useCitations.module.scss
var useCitations_module_default = {
  citationLink: "useCitations_module_citationLink3",
  citationNumber: "useCitations_module_citationNumber3",
  citationNumberCompact: "useCitations_module_citationNumberCompact3",
  citationNumberDefault: "useCitations_module_citationNumberDefault3",
  popoverLinkCompact: "useCitations_module_popoverLinkCompact3",
  popoverLinkDefault: "useCitations_module_popoverLinkDefault3",
  citationItem: "useCitations_module_citationItem3",
  citationHighlight: "useCitations_module_citationHighlight3",
  pulsate: "useCitations_module_pulsate3",
  popoverContent: "useCitations_module_popoverContent3",
  navigationSection: "useCitations_module_navigationSection3",
  divider: "useCitations_module_divider3",
  navigationButtons: "useCitations_module_navigationButtons3"
};

// src/Citations/CitationBadge.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CitationBadge = (props) => {
  const { citation, onBadgeClick, fontSize = "default" } = props;
  const handleClick = React.useCallback(() => {
    onBadgeClick?.(citation);
  }, [citation, onBadgeClick]);
  const citationNumberClass = fontSize === "compact" ? useCitations_module_default.citationNumberCompact : useCitations_module_default.citationNumberDefault;
  const popoverLinkClass = fontSize === "compact" ? useCitations_module_default.popoverLinkCompact : useCitations_module_default.popoverLinkDefault;
  if (props.interactionMode === "popup") {
    const domainLabel2 = getCitationDomainLabel(citation.url);
    return /* @__PURE__ */ jsx(
      Popover,
      {
        dismissButton: false,
        position: "top",
        size: "small",
        triggerType: "custom",
        content: /* @__PURE__ */ jsxs(SpaceBetween, { direction: "vertical", size: "xs", children: [
          /* @__PURE__ */ jsx(Box, { variant: "strong", children: citation.title }),
          citation.snippet && /* @__PURE__ */ jsx(Box, { variant: "p", children: citation.snippet }),
          /* @__PURE__ */ jsx(Link, { href: citation.url, external: true, className: popoverLinkClass, children: citation.url })
        ] }),
        children: /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            "data-testid": "citation-badge",
            className: useCitations_module_default.citationLink,
            "aria-label": `Citation from ${domainLabel2}, show details`,
            "aria-haspopup": "dialog",
            onClick: handleClick,
            children: [
              /* @__PURE__ */ jsx(Icon, { name: "anchor-link", size: "small", "aria-hidden": "true" }),
              /* @__PURE__ */ jsx("span", { className: citationNumberClass, children: domainLabel2 })
            ]
          }
        )
      }
    );
  }
  if (props.interactionMode === "scroll") {
    const handleScrollClick = (event) => {
      event.preventDefault();
      handleClick();
      const anchorId = `citation-${citation.id}`;
      const element = document.getElementById(anchorId);
      if (element) {
        props.scrollToElement(element, { behavior: "smooth" });
        element.setAttribute("tabindex", "-1");
        setTimeout(() => element.focus(), 500);
      }
    };
    const citationLabel = getCitationIdLabel(citation.id);
    return /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        "data-testid": "citation-badge",
        className: useCitations_module_default.citationLink,
        "aria-label": `Go to citation ${citationLabel}`,
        onClick: handleScrollClick,
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "anchor-link", size: "small", "aria-hidden": "true" }),
          /* @__PURE__ */ jsx("span", { className: citationNumberClass, children: citationLabel })
        ]
      }
    );
  }
  const domainLabel = getCitationDomainLabel(citation.url);
  return /* @__PURE__ */ jsxs(
    "a",
    {
      href: citation.url,
      "data-testid": "citation-badge",
      className: useCitations_module_default.citationLink,
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": `Citation from ${domainLabel}, opens in new tab`,
      onClick: (_e) => {
        handleClick();
      },
      children: [
        /* @__PURE__ */ jsx(Icon, { name: "anchor-link", size: "small", "aria-hidden": "true" }),
        /* @__PURE__ */ jsx("span", { className: citationNumberClass, children: domainLabel })
      ]
    }
  );
};

// src/Citations/MultiCitationBadge.tsx
import * as React2 from "react";
import Popover2 from "@cloudscape-design/components/popover";
import Box2 from "@cloudscape-design/components/box";
import SpaceBetween2 from "@cloudscape-design/components/space-between";
import Icon2 from "@cloudscape-design/components/icon";
import Link2 from "@cloudscape-design/components/link";
import Button from "@cloudscape-design/components/button";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function getGroupBadgeText(citations) {
  if (citations.length === 0) {
    return "";
  }
  const hasAws = citations.some((c) => getCitationDomainLabel(c.url) === "AWS");
  const priorityLabel = hasAws ? "AWS" : "External";
  if (citations.length === 1) {
    return priorityLabel;
  }
  return `${priorityLabel} +${citations.length - 1}`;
}
var MultiCitationBadge = ({ citations, onBadgeClick, fontSize = "default" }) => {
  const sortedCitations = React2.useMemo(() => {
    return [...citations].sort((a, b) => {
      const aIsAws = getCitationDomainLabel(a.url) === "AWS";
      const bIsAws = getCitationDomainLabel(b.url) === "AWS";
      if (aIsAws && !bIsAws)
        return -1;
      if (!aIsAws && bIsAws)
        return 1;
      return 0;
    });
  }, [citations]);
  const [currentIndex, setCurrentIndex] = React2.useState(0);
  const citation = sortedCitations[currentIndex];
  const handleClick = React2.useCallback(() => {
    onBadgeClick?.(citation);
  }, [citation, onBadgeClick]);
  const citationNumberClass = fontSize === "compact" ? useCitations_module_default.citationNumberCompact : useCitations_module_default.citationNumberDefault;
  const popoverLinkClass = fontSize === "compact" ? useCitations_module_default.popoverLinkCompact : useCitations_module_default.popoverLinkDefault;
  const handlePrevious = React2.useCallback(() => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  }, []);
  const handleNext = React2.useCallback(() => {
    setCurrentIndex((prev) => Math.min(sortedCitations.length - 1, prev + 1));
  }, [sortedCitations.length]);
  const badgeText = getGroupBadgeText(citations);
  return /* @__PURE__ */ jsx2(
    Popover2,
    {
      dismissButton: false,
      position: "top",
      triggerType: "custom",
      renderWithPortal: true,
      content: /* @__PURE__ */ jsxs2("div", { className: useCitations_module_default.popoverContent, "aria-live": "polite", "aria-atomic": "true", children: [
        /* @__PURE__ */ jsxs2(SpaceBetween2, { direction: "vertical", size: "xs", children: [
          /* @__PURE__ */ jsx2(Box2, { variant: "strong", children: citation.title }),
          citation.snippet && /* @__PURE__ */ jsx2(Box2, { variant: "p", children: citation.snippet }),
          /* @__PURE__ */ jsx2(Link2, { href: citation.url, external: true, className: popoverLinkClass, children: citation.url })
        ] }),
        /* @__PURE__ */ jsxs2("div", { className: useCitations_module_default.navigationSection, children: [
          /* @__PURE__ */ jsx2("hr", { className: useCitations_module_default.divider }),
          /* @__PURE__ */ jsxs2("div", { className: useCitations_module_default.navigationButtons, children: [
            /* @__PURE__ */ jsxs2(Box2, { variant: "small", color: "text-status-inactive", children: [
              "Source ",
              currentIndex + 1,
              " of ",
              sortedCitations.length
            ] }),
            /* @__PURE__ */ jsxs2(SpaceBetween2, { direction: "horizontal", size: "xs", children: [
              /* @__PURE__ */ jsx2(Button, { variant: "link", disabled: currentIndex === 0, onClick: handlePrevious, children: "Previous" }),
              /* @__PURE__ */ jsx2(Button, { disabled: currentIndex === sortedCitations.length - 1, onClick: handleNext, children: "Next" })
            ] })
          ] })
        ] })
      ] }),
      children: /* @__PURE__ */ jsxs2(
        "button",
        {
          type: "button",
          "data-testid": "citation-badge",
          className: useCitations_module_default.citationLink,
          "aria-label": `${sortedCitations.length} citations, ${badgeText}, show details`,
          "aria-haspopup": "dialog",
          onClick: handleClick,
          children: [
            /* @__PURE__ */ jsx2(Icon2, { name: "anchor-link", size: "small", "aria-hidden": "true" }),
            /* @__PURE__ */ jsx2("span", { className: citationNumberClass, children: badgeText })
          ]
        }
      )
    }
  );
};

// src/Citations/processCitationsInText.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
function processCitationsInText(text, citations, options) {
  const { pattern = /\[(\d+)\]/g, interactionMode, onBadgeClick, scrollToElement, CitationBadgeComponent = CitationBadge, fontSize } = options;
  if (!citations || citations.length === 0) {
    return [text];
  }
  const citationPattern = new RegExp(pattern.source, "g");
  const parts = [];
  const getCitation = (id) => {
    return citations.find((c) => c.id === id);
  };
  const matches = [];
  let match;
  while ((match = citationPattern.exec(text)) !== null) {
    const citationId = parseInt(match[1], 10);
    const citation = getCitation(citationId);
    matches.push({ match, citation });
  }
  if (matches.length === 0) {
    return [text];
  }
  let lastIndex = 0;
  for (let i = 0; i < matches.length; i++) {
    const { match: currentMatch, citation: currentCitation } = matches[i];
    if (!currentCitation) {
      if (currentMatch.index > lastIndex) {
        parts.push(text.substring(lastIndex, currentMatch.index));
      }
      parts.push(currentMatch[0]);
      lastIndex = currentMatch.index + currentMatch[0].length;
      continue;
    }
    if (interactionMode === "popup") {
      const groupCitations = [currentCitation];
      const groupStartIndex = currentMatch.index;
      let groupEndIndex = currentMatch.index + currentMatch[0].length;
      let j = i + 1;
      while (j < matches.length) {
        const { match: nextMatch, citation: nextCitation } = matches[j];
        if (nextCitation && nextMatch.index === groupEndIndex) {
          groupCitations.push(nextCitation);
          groupEndIndex = nextMatch.index + nextMatch[0].length;
          j++;
        } else {
          break;
        }
      }
      if (groupStartIndex > lastIndex) {
        parts.push(text.substring(lastIndex, groupStartIndex));
      }
      if (groupCitations.length > 1) {
        parts.push(
          /* @__PURE__ */ jsx3(MultiCitationBadge, { citations: groupCitations, onBadgeClick, fontSize }, `citation-group-${groupStartIndex}`)
        );
      } else {
        const Component = CitationBadgeComponent;
        parts.push(
          /* @__PURE__ */ jsx3(
            Component,
            {
              citation: currentCitation,
              interactionMode: "popup",
              onBadgeClick,
              fontSize
            },
            `citation-${groupStartIndex}`
          )
        );
      }
      lastIndex = groupEndIndex;
      i = j - 1;
    } else {
      if (currentMatch.index > lastIndex) {
        parts.push(text.substring(lastIndex, currentMatch.index));
      }
      const Component = CitationBadgeComponent;
      if (interactionMode === "link") {
        parts.push(
          /* @__PURE__ */ jsx3(
            Component,
            {
              citation: currentCitation,
              interactionMode: "link",
              onBadgeClick,
              fontSize
            },
            `citation-${currentMatch.index}`
          )
        );
      } else {
        if (!scrollToElement) {
          throw new Error("scrollToElement is required for scroll mode");
        }
        parts.push(
          /* @__PURE__ */ jsx3(
            Component,
            {
              citation: currentCitation,
              interactionMode: "scroll",
              scrollToElement,
              onBadgeClick,
              fontSize
            },
            `citation-${currentMatch.index}`
          )
        );
      }
      lastIndex = currentMatch.index + currentMatch[0].length;
    }
  }
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  return parts;
}

// src/SkeletonBlock/SkeletonBlock.tsx
var import_classnames = __toESM(require_classnames(), 1);

// src/SkeletonBlock/SkeletonBlock.module.scss
var SkeletonBlock_module_default = {
  shimmer: "SkeletonBlock_module_shimmer",
  skeleton: "SkeletonBlock_module_skeleton"
};

// src/SkeletonBlock/SkeletonBlock.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var SkeletonBlock = ({ width = "100%", height, borderRadius = 4, className }) => {
  const style = {
    width: typeof width === "number" ? `${width}px` : width,
    height: `${height}px`,
    borderRadius: `${borderRadius}px`
  };
  return /* @__PURE__ */ jsx4("div", { className: (0, import_classnames.default)(SkeletonBlock_module_default.skeleton, className), style });
};

// src/ProductCard/ProductCard.tsx
import { ListingBadge as ListingBadge2 } from "@amzn/apo-ux-patterns/components/ListingBadge";

// src/TrkTracking/trk-tracking.ts
function getTrk() {
  const params = new URLSearchParams(window.location.search);
  return params.get("trk");
}
function appendTrk(url) {
  if (!url) {
    return void 0;
  }
  const trk = getTrk();
  if (!trk) {
    return url;
  }
  const fragmentIndex = url.indexOf("#");
  const urlWithoutFragment = fragmentIndex === -1 ? url : url.slice(0, fragmentIndex);
  const fragment = fragmentIndex === -1 ? "" : url.slice(fragmentIndex);
  const queryIndex = urlWithoutFragment.indexOf("?");
  const queryString = queryIndex === -1 ? "" : urlWithoutFragment.slice(queryIndex);
  const existingParams = new URLSearchParams(queryString);
  if (existingParams.has("trk")) {
    return url;
  }
  const encodedTrk = encodeURIComponent(trk);
  const separator = queryIndex === -1 ? "?" : "&";
  return `${urlWithoutFragment}${separator}trk=${encodedTrk}${fragment}`;
}

// src/ProductCard/ProductCardLayout.tsx
import Box3 from "@cloudscape-design/components/box";
import SpaceBetween3 from "@cloudscape-design/components/space-between";
import { colorBorderDividerSecondary } from "@cloudscape-design/design-tokens";
import { Fragment, jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var ProductCardLayout = ({
  logo,
  availableOptionsLink,
  availableOptionsSection,
  productName,
  vendor,
  rating,
  description,
  badge,
  button
}) => {
  return /* @__PURE__ */ jsxs3(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: "320px"
      },
      children: [
        /* @__PURE__ */ jsx5("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxs3(SpaceBetween3, { direction: "vertical", size: "xs", children: [
          /* @__PURE__ */ jsxs3("div", { style: { display: "flex", gap: "12px" }, children: [
            /* @__PURE__ */ jsx5("div", { style: { flexShrink: 0 }, children: /* @__PURE__ */ jsxs3(
              "div",
              {
                style: {
                  width: "84px",
                  height: availableOptionsLink ? "auto" : "84px",
                  display: "flex",
                  flexDirection: "column",
                  border: `1px solid ${colorBorderDividerSecondary}`,
                  borderRadius: "12px",
                  backgroundColor: "#ffffff",
                  overflow: "hidden"
                },
                children: [
                  /* @__PURE__ */ jsx5(
                    "div",
                    {
                      style: {
                        width: "100%",
                        height: availableOptionsLink ? "60px" : "100%",
                        padding: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box"
                      },
                      children: logo || null
                    }
                  ),
                  availableOptionsLink && /* @__PURE__ */ jsxs3(Fragment, { children: [
                    /* @__PURE__ */ jsx5("div", { style: { width: "100%", height: "1px", backgroundColor: colorBorderDividerSecondary } }),
                    /* @__PURE__ */ jsx5("div", { style: { padding: "4px 4px", fontSize: "9px", textAlign: "center", whiteSpace: "nowrap" }, children: availableOptionsLink })
                  ] })
                ]
              }
            ) }),
            /* @__PURE__ */ jsxs3("div", { style: { flex: 1, minWidth: 0 }, children: [
              /* @__PURE__ */ jsx5(
                "div",
                {
                  style: {
                    marginBottom: "4px",
                    minHeight: "44px",
                    // Space for 2 lines of product name text
                    display: "flex",
                    alignItems: "flex-start"
                  },
                  children: /* @__PURE__ */ jsx5("div", { style: { flex: 1 }, children: productName })
                }
              ),
              vendor
            ] })
          ] }),
          rating,
          badge,
          /* @__PURE__ */ jsx5("hr", { style: { margin: 0, border: "none", borderTop: `1px solid ${colorBorderDividerSecondary}` } }),
          description,
          availableOptionsSection
        ] }) }),
        /* @__PURE__ */ jsx5(Box3, { margin: { top: "s" }, textAlign: "right", children: button })
      ]
    }
  );
};

// src/ProductCard/ProductCardSkeleton.tsx
import Box4 from "@cloudscape-design/components/box";
import Container from "@cloudscape-design/components/container";
import Icon3 from "@cloudscape-design/components/icon";

// src/ProductCard/ProductCard.module.scss
var ProductCard_module_default = {
  "full-height-container": "ProductCard_module_full-height-container",
  fadeOut: "ProductCard_module_fadeOut",
  collapseWidth: "ProductCard_module_collapseWidth",
  "card-fading": "ProductCard_module_card-fading",
  "card-collapsing": "ProductCard_module_card-collapsing",
  aiSummaryText: "ProductCard_module_aiSummaryText",
  availableOptionsLabel: "ProductCard_module_availableOptionsLabel",
  availableOptionsLinks: "ProductCard_module_availableOptionsLinks",
  availableOptionsMore: "ProductCard_module_availableOptionsMore"
};

// src/ProductCard/ProductCardSkeleton.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var ProductCardSkeleton = () => /* @__PURE__ */ jsx6("div", { style: { height: "100%", display: "flex", flexDirection: "column" }, children: /* @__PURE__ */ jsx6(Container, { className: ProductCard_module_default["full-height-container"], children: /* @__PURE__ */ jsx6(
  ProductCardLayout,
  {
    logo: /* @__PURE__ */ jsx6(SkeletonBlock, { height: 56, width: 56 }),
    productName: /* @__PURE__ */ jsx6("div", { children: /* @__PURE__ */ jsx6(SkeletonBlock, { height: 16, width: "90%" }) }),
    vendor: /* @__PURE__ */ jsx6(SkeletonBlock, { height: 14, width: "70%" }),
    rating: /* @__PURE__ */ jsx6(SkeletonBlock, { height: 18, width: "60%" }),
    description: /* @__PURE__ */ jsx6(Box4, { children: /* @__PURE__ */ jsxs4("div", { style: { display: "flex", gap: "8px", alignItems: "flex-start" }, children: [
      /* @__PURE__ */ jsx6("div", { style: { width: "16px", flexShrink: 0 }, children: /* @__PURE__ */ jsx6(Icon3, { size: "small", name: "gen-ai", variant: "disabled" }) }),
      /* @__PURE__ */ jsxs4("div", { style: { flex: 1, display: "flex", flexDirection: "column", gap: "8px" }, children: [
        /* @__PURE__ */ jsx6(SkeletonBlock, { height: 14 }),
        /* @__PURE__ */ jsx6(SkeletonBlock, { height: 14 }),
        /* @__PURE__ */ jsx6(SkeletonBlock, { height: 14, width: "85%" })
      ] })
    ] }) }),
    button: /* @__PURE__ */ jsx6(SkeletonBlock, { height: 32 })
  }
) }) });

// src/ProductDeepLinks/ProductDeepLinks.tsx
import ButtonDropdown from "@cloudscape-design/components/button-dropdown";
import { useAppTranslation } from "@amzn/awsmp-max-translations";
import { appendTrk as appendTrk2 } from "@amzn/awsmp-max-ux-patterns/TrkTracking";
import { jsx as jsx7 } from "react/jsx-runtime";
var ProductDeepLinks = ({
  pdpUrl,
  procurementUrl,
  requestADemoUrl,
  requestPrivateOfferUrl,
  procureFreeTrialUrl,
  onCreateProposal,
  fullWidth = false,
  disabled = false,
  logger
}) => {
  const { t } = useAppTranslation();
  const allItems = [];
  allItems.push({
    id: "view-details",
    text: t("viewProductDetails"),
    href: appendTrk2(pdpUrl),
    external: true,
    externalIconAriaLabel: t("opensInNewTab")
  });
  if (procurementUrl) {
    allItems.push({
      id: "view-purchase-options",
      text: t("viewPurchaseOptions"),
      href: appendTrk2(procurementUrl),
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (procureFreeTrialUrl) {
    allItems.push({
      id: "try-for-free",
      text: t("tryForFree"),
      href: appendTrk2(procureFreeTrialUrl),
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (requestADemoUrl) {
    allItems.push({
      id: "request-demo",
      text: t("requestDemo"),
      href: appendTrk2(requestADemoUrl),
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (requestPrivateOfferUrl) {
    allItems.push({
      id: "request-private-offer",
      text: t("requestPrivateOffer"),
      href: appendTrk2(requestPrivateOfferUrl),
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (onCreateProposal) {
    allItems.push({
      id: "create-proposal",
      text: t("createProposal"),
      iconName: "gen-ai"
    });
  }
  const items = [
    {
      items: allItems
    }
  ];
  const handleItemClick = (event) => {
    if (event.detail.id === "create-proposal" && onCreateProposal) {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "create-proposal-button"
        }
      });
      onCreateProposal();
    }
    if (event.detail.id === "view-details") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "view-details-button"
        }
      });
    }
    if (event.detail.id === "view-purchase-options") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "view-purchase-options-button"
        }
      });
    }
    if (event.detail.id === "try-for-free") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "try-for-free-button"
        }
      });
    }
    if (event.detail.id === "request-demo") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "request-demo-button"
        }
      });
    }
    if (event.detail.id === "request-private-offer") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "request-private-offer-button"
        }
      });
    }
  };
  return /* @__PURE__ */ jsx7(ButtonDropdown, { items, variant: "normal", fullWidth, onItemClick: handleItemClick, disabled, children: t("getStarted") });
};

// src/ProductCard/AvailableOptionsSection.tsx
import * as React4 from "react";
import Link4 from "@cloudscape-design/components/link";
import { useAppTranslation as useAppTranslation3 } from "@amzn/awsmp-max-translations";

// src/ProductCard/AvailableOptionsModal.tsx
import * as React3 from "react";
import Box6 from "@cloudscape-design/components/box";
import Button2 from "@cloudscape-design/components/button";
import Link3 from "@cloudscape-design/components/link";
import Modal from "@cloudscape-design/components/modal";
import Select from "@cloudscape-design/components/select";
import SpaceBetween4 from "@cloudscape-design/components/space-between";
import Table from "@cloudscape-design/components/table";
import TextFilter from "@cloudscape-design/components/text-filter";
import Pagination from "@cloudscape-design/components/pagination";
import { useAppTranslation as useAppTranslation2 } from "@amzn/awsmp-max-translations";
import { ListingBadge } from "@amzn/apo-ux-patterns/components/ListingBadge";

// src/StarRating/StarRating.tsx
import Box5 from "@cloudscape-design/components/box";
import Icon4 from "@cloudscape-design/components/icon";
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var StarRating = ({ rating, reviewCount }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const stars = [];
  for (let i = 0; i < fullStars; i++) {
    stars.push(
      /* @__PURE__ */ jsx8("span", { style: { color: "#FF9900" }, children: /* @__PURE__ */ jsx8(Icon4, { name: "star-filled", size: "small" }) }, `full-${i}`)
    );
  }
  if (hasHalfStar && fullStars < 5) {
    stars.push(
      /* @__PURE__ */ jsx8("span", { style: { color: "#FF9900" }, children: /* @__PURE__ */ jsx8(Icon4, { name: "star-half", size: "small" }) }, "half")
    );
  }
  return /* @__PURE__ */ jsxs5("div", { style: { display: "flex", alignItems: "center", gap: "4px" }, children: [
    /* @__PURE__ */ jsx8(Box5, { variant: "small", color: "text-body-secondary", children: rating.toFixed(1) }),
    /* @__PURE__ */ jsx8("div", { style: { display: "flex", alignItems: "center", gap: "2px" }, children: stars }),
    reviewCount !== void 0 && /* @__PURE__ */ jsxs5(Box5, { variant: "small", color: "text-body-secondary", children: [
      "(",
      reviewCount,
      ")"
    ] })
  ] });
};

// src/ProductCard/AvailableOptionsModal.tsx
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var ITEMS_PER_PAGE = 10;
var AvailableOptionsModal = ({
  visible,
  onDismiss,
  productName,
  productUrl,
  vendorName,
  vendorUrl,
  options
}) => {
  const { t } = useAppTranslation2();
  const [filterText, setFilterText] = React3.useState("");
  const [currentPage, setCurrentPage] = React3.useState(1);
  const [selectedPricingModel, setSelectedPricingModel] = React3.useState(null);
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = React3.useState(null);
  const pricingModelOptions = React3.useMemo(() => {
    const uniqueModels = [...new Set(options.map((opt) => opt.pricingModel).filter(Boolean))];
    return [{ label: t("allPricingModels"), value: "" }, ...uniqueModels.map((model) => ({ label: model, value: model }))];
  }, [options, t]);
  const deliveryMethodOptions = React3.useMemo(() => {
    const uniqueMethods = [...new Set(options.map((opt) => opt.deliveryMethod).filter(Boolean))];
    return [{ label: t("allDeliveryMethods"), value: "" }, ...uniqueMethods.map((method) => ({ label: method, value: method }))];
  }, [options, t]);
  React3.useEffect(() => {
    if (visible) {
      setFilterText("");
      setCurrentPage(1);
      setSelectedPricingModel(null);
      setSelectedDeliveryMethod(null);
    }
  }, [visible]);
  const filteredItems = React3.useMemo(() => {
    let filtered = options;
    if (filterText) {
      const lowerFilter = filterText.toLowerCase();
      filtered = filtered.filter((item) => item.productName?.toLowerCase().includes(lowerFilter));
    }
    if (selectedPricingModel?.value) {
      filtered = filtered.filter((item) => item.pricingModel === selectedPricingModel.value);
    }
    if (selectedDeliveryMethod?.value) {
      filtered = filtered.filter((item) => item.deliveryMethod === selectedDeliveryMethod.value);
    }
    return filtered;
  }, [options, filterText, selectedPricingModel, selectedDeliveryMethod]);
  const paginatedItems = React3.useMemo(() => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredItems.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  }, [filteredItems, currentPage]);
  const pagesCount = Math.ceil(filteredItems.length / ITEMS_PER_PAGE);
  const columnDefinitions = [
    {
      id: "productName",
      header: t("productName"),
      cell: (item) => /* @__PURE__ */ jsx9(Link3, { href: appendTrk(item.productUrl), variant: "primary", children: item.productName }),
      width: 260
    },
    {
      id: "reviews",
      header: t("reviews"),
      cell: (item) => item.starRating ? /* @__PURE__ */ jsx9(StarRating, { rating: item.starRating, reviewCount: item.reviewCount }) : "-",
      width: 180
    },
    {
      id: "badges",
      header: t("badges"),
      cell: (item) => item.badges && item.badges.length > 0 ? /* @__PURE__ */ jsx9("div", { style: { display: "flex", flexWrap: "wrap", gap: "4px" }, children: item.badges.map((badge) => /* @__PURE__ */ jsx9(ListingBadge, { variant: badge }, badge)) }) : "-",
      width: 200
    },
    {
      id: "pricingModel",
      header: t("pricingModel"),
      cell: (item) => item.pricingModel || "-",
      width: 150
    },
    {
      id: "deliveryMethod",
      header: t("deliveryMethod"),
      cell: (item) => item.deliveryMethod || "-",
      width: 150
    }
  ];
  return /* @__PURE__ */ jsx9(
    Modal,
    {
      visible,
      onDismiss,
      size: "large",
      header: t("availableOptionsCount", { count: options.length }),
      footer: /* @__PURE__ */ jsx9(Box6, { float: "right", children: /* @__PURE__ */ jsx9(Button2, { variant: "primary", onClick: onDismiss, children: t("close") }) }),
      children: /* @__PURE__ */ jsxs6(SpaceBetween4, { direction: "vertical", size: "m", children: [
        /* @__PURE__ */ jsxs6(Box6, { variant: "p", children: [
          "The following are available options for",
          " ",
          productUrl ? /* @__PURE__ */ jsx9(Link3, { href: appendTrk(productUrl), external: true, children: productName }) : productName,
          " ",
          "from",
          " ",
          vendorUrl ? /* @__PURE__ */ jsx9(Link3, { href: vendorUrl, external: true, children: vendorName }) : vendorName,
          " ",
          "filtered based on your search criteria."
        ] }),
        /* @__PURE__ */ jsx9(
          Table,
          {
            items: paginatedItems,
            columnDefinitions,
            variant: "embedded",
            wrapLines: true,
            filter: /* @__PURE__ */ jsxs6(SpaceBetween4, { direction: "horizontal", size: "s", children: [
              /* @__PURE__ */ jsx9(
                TextFilter,
                {
                  filteringText: filterText,
                  filteringPlaceholder: t("findProduct"),
                  onChange: ({ detail }) => {
                    setFilterText(detail.filteringText);
                    setCurrentPage(1);
                  }
                }
              ),
              /* @__PURE__ */ jsx9(
                Select,
                {
                  selectedOption: selectedPricingModel,
                  onChange: ({ detail }) => {
                    setSelectedPricingModel(detail.selectedOption);
                    setCurrentPage(1);
                  },
                  options: pricingModelOptions,
                  placeholder: t("anyPricingModel")
                }
              ),
              /* @__PURE__ */ jsx9(
                Select,
                {
                  selectedOption: selectedDeliveryMethod,
                  onChange: ({ detail }) => {
                    setSelectedDeliveryMethod(detail.selectedOption);
                    setCurrentPage(1);
                  },
                  options: deliveryMethodOptions,
                  placeholder: t("anyDeliveryMethod")
                }
              )
            ] }),
            pagination: pagesCount > 1 ? /* @__PURE__ */ jsx9(Pagination, { currentPageIndex: currentPage, pagesCount, onChange: ({ detail }) => setCurrentPage(detail.currentPageIndex) }) : void 0,
            empty: /* @__PURE__ */ jsx9(Box6, { textAlign: "center", color: "inherit", padding: "l", children: /* @__PURE__ */ jsx9("b", { children: t("noOptionsAvailable") }) })
          }
        )
      ] })
    }
  );
};

// src/ProductCard/AvailableOptionsSection.tsx
import { Fragment as Fragment2, jsx as jsx10, jsxs as jsxs7 } from "react/jsx-runtime";
var MAX_VISIBLE_OPTIONS = 2;
var AvailableOptionsSection = ({ productName, productUrl, vendorName, vendorUrl, options }) => {
  const { t } = useAppTranslation3();
  const [modalVisible, setModalVisible] = React4.useState(false);
  if (!options || options.length <= 1) {
    return null;
  }
  const handleOpenModal = () => {
    setModalVisible(true);
  };
  const handleCloseModal = () => {
    setModalVisible(false);
  };
  const visibleOptions = options.slice(0, MAX_VISIBLE_OPTIONS);
  const remainingCount = options.length - MAX_VISIBLE_OPTIONS;
  return /* @__PURE__ */ jsxs7(Fragment2, { children: [
    /* @__PURE__ */ jsxs7("div", { children: [
      /* @__PURE__ */ jsxs7("div", { className: ProductCard_module_default.availableOptionsLabel, children: [
        t("availableOptions"),
        ":"
      ] }),
      /* @__PURE__ */ jsx10("div", { className: ProductCard_module_default.availableOptionsLinks, children: visibleOptions.map((option) => /* @__PURE__ */ jsx10("div", { children: /* @__PURE__ */ jsx10(Link4, { href: option.productUrl, variant: "primary", fontSize: "body-s", children: option.productName }) }, option.productId)) }),
      remainingCount > 0 && /* @__PURE__ */ jsx10("div", { className: ProductCard_module_default.availableOptionsMore, children: /* @__PURE__ */ jsx10(Link4, { variant: "primary", fontSize: "body-s", onFollow: handleOpenModal, children: /* @__PURE__ */ jsxs7("b", { children: [
        "+ ",
        remainingCount,
        " ",
        t("more")
      ] }) }) })
    ] }),
    /* @__PURE__ */ jsx10(
      AvailableOptionsModal,
      {
        visible: modalVisible,
        onDismiss: handleCloseModal,
        productName,
        productUrl,
        vendorName,
        vendorUrl,
        options
      }
    )
  ] });
};

// src/ProductCard/AvailableOptionsLink.tsx
import * as React5 from "react";
import { useAppTranslation as useAppTranslation4 } from "@amzn/awsmp-max-translations";
import { Fragment as Fragment3, jsx as jsx11, jsxs as jsxs8 } from "react/jsx-runtime";
var AvailableOptionsLink = ({ productName, vendorName, options, logger }) => {
  const { t } = useAppTranslation4();
  const [modalVisible, setModalVisible] = React5.useState(false);
  if (!options || options.length <= 1) {
    return null;
  }
  const handleOpenModal = () => {
    logger?.biMetric({
      metricName: "Click",
      value: 1,
      unit: "Count",
      dimensions: {
        ClickSelect: "available-options-link",
        ClickAct: `${options.length}-options`
      }
    });
    setModalVisible(true);
  };
  const handleCloseModal = () => {
    setModalVisible(false);
  };
  return /* @__PURE__ */ jsxs8(Fragment3, { children: [
    /* @__PURE__ */ jsxs8(
      "span",
      {
        style: {
          textDecoration: "underline",
          cursor: "pointer",
          color: "#545b64"
          // Cloudscape secondary text color
        },
        onClick: handleOpenModal,
        role: "button",
        tabIndex: 0,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleOpenModal();
          }
        },
        children: [
          options.length,
          " ",
          t("availableOptions").toLowerCase()
        ]
      }
    ),
    /* @__PURE__ */ jsx11(
      AvailableOptionsModal,
      {
        visible: modalVisible,
        onDismiss: handleCloseModal,
        productName,
        vendorName,
        options
      }
    )
  ] });
};

// src/ProductCard/ProductCard.tsx
import { Fragment as Fragment4, jsx as jsx12, jsxs as jsxs9 } from "react/jsx-runtime";
var ProductCard = ({
  product,
  variant,
  onRemove,
  onCreateProposal,
  disabled = false,
  renderAiSummaryWrapper,
  availableOptions,
  logger
}) => {
  const { t } = useAppTranslation5();
  const renderStarRating = (result) => {
    const rating2 = result.starRating || 0;
    const fullStars = Math.floor(rating2);
    const hasHalfStar = rating2 % 1 >= 0.5;
    const stars = [];
    const internalReviewCount = result.internalReviewCount || 0;
    const externalReviewCount = result.externalReviewCount || 0;
    const totalReviewCount = internalReviewCount + externalReviewCount;
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        /* @__PURE__ */ jsx12("span", { style: { color: "#FF9900" }, children: /* @__PURE__ */ jsx12(Icon5, { name: "star-filled", size: "small" }) }, `full-${i}`)
      );
    }
    if (hasHalfStar && fullStars < 5) {
      stars.push(
        /* @__PURE__ */ jsx12("span", { style: { color: "#FF9900" }, children: /* @__PURE__ */ jsx12(Icon5, { name: "star-half", size: "small" }) }, "half")
      );
    }
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        /* @__PURE__ */ jsx12("span", { style: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ jsx12(Icon5, { name: "star", size: "small", variant: "subtle" }) }, `empty-${i}`)
      );
    }
    return /* @__PURE__ */ jsxs9("div", { style: { display: "flex", alignItems: "center", gap: "4px", flexWrap: "wrap" }, children: [
      /* @__PURE__ */ jsx12(Box7, { variant: "small", color: "text-body-secondary", fontSize: "body-s", children: rating2.toFixed(1) }),
      /* @__PURE__ */ jsx12("div", { style: { display: "flex", alignItems: "center", gap: "2px", lineHeight: "1" }, children: stars }),
      /* @__PURE__ */ jsx12(Box7, { variant: "small", color: "text-body-secondary", fontSize: "body-s", children: totalReviewCount > 0 && (result.reviewUrl ? /* @__PURE__ */ jsxs9(
        Link5,
        {
          href: result.reviewUrl,
          external: true,
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              value: 1,
              unit: "Count",
              dimensions: {
                ClickSelect: "product-card-review-link",
                ClickAct: result.productId || "unknown"
              }
            });
          },
          children: [
            "(",
            totalReviewCount,
            ")"
          ]
        }
      ) : /* @__PURE__ */ jsxs9(Fragment4, { children: [
        "(",
        totalReviewCount,
        ")"
      ] })) })
    ] });
  };
  if (variant === "loading") {
    return /* @__PURE__ */ jsx12(ProductCardSkeleton, {});
  }
  if (variant === "partial") {
    const partialLogo = product.logoUrl ? /* @__PURE__ */ jsx12(
      "img",
      {
        src: product.logoUrl,
        alt: `${product.vendorName || t("product")} logo`,
        style: {
          maxWidth: "56px",
          maxHeight: "56px",
          objectFit: "contain",
          borderRadius: "4px"
        },
        onError: (e) => {
          e.target.style.display = "none";
        }
      }
    ) : /* @__PURE__ */ jsx12(SkeletonBlock, { height: 56, width: 56 });
    const aiSummaryContent = product.aiSummary ? /* @__PURE__ */ jsx12(Box7, { children: /* @__PURE__ */ jsx12(SpaceBetween5, { direction: "vertical", size: "s", children: product.aiSummary.map((summary, index) => /* @__PURE__ */ jsxs9("div", { style: { display: "flex", gap: "8px", alignItems: "flex-start" }, children: [
      /* @__PURE__ */ jsx12("span", { style: { color: "#8B46FF", flexShrink: 0 }, children: /* @__PURE__ */ jsx12(Icon5, { size: "small", name: "gen-ai" }) }),
      /* @__PURE__ */ jsx12(Box7, { variant: "small", color: "text-body-secondary", children: /* @__PURE__ */ jsx12("div", { className: ProductCard_module_default.aiSummaryText, children: summary.text }) })
    ] }, index)) }) }) : null;
    const partialDescription = product.aiSummary ? renderAiSummaryWrapper ? renderAiSummaryWrapper(aiSummaryContent) : aiSummaryContent : /* @__PURE__ */ jsx12(Box7, { children: /* @__PURE__ */ jsxs9("div", { style: { display: "flex", gap: "8px", alignItems: "flex-start" }, children: [
      /* @__PURE__ */ jsx12("div", { style: { width: "16px", flexShrink: 0 }, children: /* @__PURE__ */ jsx12(Icon5, { size: "small", name: "gen-ai", variant: "disabled" }) }),
      /* @__PURE__ */ jsxs9("div", { style: { flex: 1, display: "flex", flexDirection: "column", gap: "8px" }, children: [
        /* @__PURE__ */ jsx12(SkeletonBlock, { height: 14 }),
        /* @__PURE__ */ jsx12(SkeletonBlock, { height: 14 }),
        /* @__PURE__ */ jsx12(SkeletonBlock, { height: 14, width: "85%" })
      ] })
    ] }) });
    const partialProductName = product.productName ? /* @__PURE__ */ jsx12("div", { children: /* @__PURE__ */ jsx12(
      Link5,
      {
        href: appendTrk(product.productUrl),
        fontSize: "body-m",
        onClick: () => {
          logger.biMetric({
            metricName: "Click",
            value: 1,
            unit: "Count",
            dimensions: {
              ClickSelect: "product-card-title-link",
              ClickAct: product.productId || "unknown"
            }
          });
        },
        children: /* @__PURE__ */ jsx12("strong", { style: { wordWrap: "break-word", overflowWrap: "break-word" }, children: product.productName })
      }
    ) }) : /* @__PURE__ */ jsx12("div", { children: /* @__PURE__ */ jsx12(SkeletonBlock, { height: 16, width: "90%" }) });
    const partialVendor = product.vendorName ? /* @__PURE__ */ jsxs9(Box7, { variant: "small", color: "text-body-secondary", children: [
      "by ",
      product.vendorName
    ] }) : /* @__PURE__ */ jsx12(SkeletonBlock, { height: 14, width: "70%" });
    const partialRating = product.starRating && product.starRating > 0 ? /* @__PURE__ */ jsx12(Box7, { children: renderStarRating(product) }) : null;
    const partialBadges = product.badges && product.badges.length > 0 ? /* @__PURE__ */ jsx12(Box7, { children: /* @__PURE__ */ jsx12("div", { style: { display: "flex", flexWrap: "wrap", gap: "4px" }, children: product.badges.map((badgeName) => /* @__PURE__ */ jsx12(ListingBadge2, { variant: badgeName }, badgeName)) }) }) : null;
    const partialDeepLinks = /* @__PURE__ */ jsx12(
      ProductDeepLinks,
      {
        pdpUrl: product.productUrl,
        procurementUrl: product.procurementUrl,
        requestADemoUrl: product.requestADemoUrl,
        requestPrivateOfferUrl: product.requestPrivateOfferUrl,
        procureFreeTrialUrl: product.procureFreeTrialUrl,
        onCreateProposal: onCreateProposal && product.productId && product.productName && product.vendorName ? () => onCreateProposal(product.productId, product.productName, product.vendorName) : void 0,
        disabled,
        logger
      }
    );
    return /* @__PURE__ */ jsx12("div", { style: { height: "100%", display: "flex", flexDirection: "column" }, children: /* @__PURE__ */ jsx12(Container2, { className: ProductCard_module_default["full-height-container"], children: /* @__PURE__ */ jsx12(
      ProductCardLayout,
      {
        logo: partialLogo,
        productName: partialProductName,
        vendor: partialVendor,
        rating: partialRating,
        badge: partialBadges,
        description: partialDescription,
        button: partialDeepLinks
      }
    ) }) });
  }
  const logo = product.logoUrl ? /* @__PURE__ */ jsx12(
    "img",
    {
      src: product.logoUrl,
      alt: `${product.vendorName || t("product")} logo`,
      style: {
        maxWidth: "56px",
        maxHeight: "56px",
        objectFit: "contain"
      },
      onError: (e) => {
        e.target.style.display = "none";
      }
    }
  ) : null;
  const productName = /* @__PURE__ */ jsxs9("div", { children: [
    onRemove && product.productId && product.productName && /* @__PURE__ */ jsx12("div", { style: { float: "right", marginTop: "-8px", marginRight: "-8px", marginLeft: "8px" }, children: /* @__PURE__ */ jsx12(
      Button3,
      {
        variant: "icon",
        iconName: "close",
        ariaLabel: `Remove ${product.productName}`,
        onClick: () => onRemove(product.productId, product.productName),
        disabled
      }
    ) }),
    /* @__PURE__ */ jsx12(
      Link5,
      {
        href: appendTrk(product.productUrl),
        fontSize: "body-m",
        onClick: () => {
          logger.biMetric({
            metricName: "Click",
            value: 1,
            unit: "Count",
            dimensions: {
              ClickSelect: "product-card-title-link",
              ClickAct: product.productId || "unknown"
            }
          });
        },
        children: /* @__PURE__ */ jsx12("strong", { style: { wordWrap: "break-word", overflowWrap: "break-word" }, children: product.productName || t("product") })
      }
    ),
    /* @__PURE__ */ jsx12("div", { style: { clear: "both" } })
  ] });
  const vendor = /* @__PURE__ */ jsxs9(Box7, { variant: "small", color: "text-body-secondary", children: [
    "by ",
    product.vendorName || "Unknown Vendor"
  ] });
  const rating = product.starRating && product.starRating > 0 ? /* @__PURE__ */ jsx12(Box7, { children: renderStarRating(product) }) : null;
  const normalAiSummaryContent = product.aiSummary ? /* @__PURE__ */ jsx12(Box7, { children: /* @__PURE__ */ jsx12(SpaceBetween5, { direction: "vertical", size: "s", children: product.aiSummary.map((summary, index) => /* @__PURE__ */ jsxs9("div", { style: { display: "flex", gap: "8px", alignItems: "flex-start" }, children: [
    /* @__PURE__ */ jsx12("span", { style: { color: "#8B46FF", flexShrink: 0 }, children: /* @__PURE__ */ jsx12(Icon5, { size: "small", name: "gen-ai" }) }),
    /* @__PURE__ */ jsx12(Box7, { variant: "small", color: "text-body-secondary", children: /* @__PURE__ */ jsx12("div", { className: ProductCard_module_default.aiSummaryText, children: processCitationsInText(summary.text, summary.citations || [], { interactionMode: "popup", fontSize: "compact" }) }) })
  ] }, index)) }) }) : null;
  const description = product.aiSummary ? renderAiSummaryWrapper ? renderAiSummaryWrapper(normalAiSummaryContent) : normalAiSummaryContent : null;
  const badges = product.badges && product.badges.length > 0 ? /* @__PURE__ */ jsx12(Box7, { children: /* @__PURE__ */ jsx12("div", { style: { display: "flex", flexWrap: "wrap", gap: "4px" }, children: product.badges.map((badgeName) => /* @__PURE__ */ jsx12(ListingBadge2, { variant: badgeName }, badgeName)) }) }) : null;
  const deepLinks = /* @__PURE__ */ jsx12(
    ProductDeepLinks,
    {
      pdpUrl: product.productUrl,
      procurementUrl: product.procurementUrl,
      requestADemoUrl: product.requestADemoUrl,
      requestPrivateOfferUrl: product.requestPrivateOfferUrl,
      procureFreeTrialUrl: product.procureFreeTrialUrl,
      onCreateProposal: onCreateProposal && product.productId && product.productName && product.vendorName ? () => onCreateProposal(product.productId, product.productName, product.vendorName) : void 0,
      disabled,
      logger
    }
  );
  const vendorUrl = product.vendorId ? `https://aws.amazon.com/marketplace/seller-profile?id=${product.vendorId}` : void 0;
  const availableOptionsSectionElement = availableOptions && availableOptions.length > 1 ? /* @__PURE__ */ jsx12(
    AvailableOptionsSection,
    {
      productName: product.productName || "",
      productUrl: appendTrk(product.productUrl),
      vendorName: product.vendorName || "",
      vendorUrl,
      options: availableOptions
    }
  ) : null;
  const availableOptionsLinkElement = availableOptions && availableOptions.length > 1 ? /* @__PURE__ */ jsx12(
    AvailableOptionsLink,
    {
      productName: product.productName || "",
      vendorName: product.vendorName || "",
      options: availableOptions,
      logger
    }
  ) : null;
  return /* @__PURE__ */ jsx12("div", { style: { height: "100%", display: "flex", flexDirection: "column" }, children: /* @__PURE__ */ jsx12(
    Container2,
    {
      className: (0, import_classnames2.default)(ProductCard_module_default["full-height-container"], {
        [ProductCard_module_default["card-fading"]]: variant === "hide"
      }),
      children: /* @__PURE__ */ jsx12(
        ProductCardLayout,
        {
          logo,
          availableOptionsLink: availableOptionsLinkElement,
          availableOptionsSection: availableOptionsSectionElement,
          productName,
          vendor,
          rating,
          description,
          badge: badges,
          button: deepLinks
        }
      )
    }
  ) });
};

// src/ProductCard/utils.ts
function transformVariantsToOptions(variants) {
  if (!variants || variants.length === 0) {
    return [];
  }
  return variants.map((variant) => ({
    productId: variant.variantId,
    productName: variant.variantName,
    productUrl: `https://aws.amazon.com/marketplace/pp/${variant.variantId}`,
    starRating: variant.starRating,
    reviewCount: (variant.internalReviewCount ?? 0) + (variant.externalReviewCount ?? 0),
    badges: variant.badges,
    pricingModel: variant.pricingModel,
    deliveryMethod: variant.deploymentModel?.join(", ")
  }));
}
export {
  AvailableOptionsLink,
  AvailableOptionsModal,
  AvailableOptionsSection,
  ProductCard,
  ProductCardSkeleton,
  transformVariantsToOptions
};
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/
//# sourceMappingURL=index.js.map
